import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import { Button as PrimeButton } from "primereact/button";
import { Dialog } from "primereact/dialog";
import ToolTip from "../common/ToolTip";
import usePermission from "../../usePermission";
import { ICONS } from "../../constants/icons";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";

import { InlineDownloadProgress } from "../common/InlineDownloadProgress";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";

export default function Toolbox(props: {
  isLoading: boolean;
  isTabValue: boolean;
  addComment: () => void;
  editMasterFilling: () => void;
  deleteMasterRecord: () => void;
  displayAttachments: () => void;
  displayHistory: () => void;
  displayClients: () => void;
  // downloadData: () => void;
  downloadData: () => void;
  downloadDataHistory: () => void;
  draft: any;
  downloadProgress?: number;
  downloadStatusMsg?: string;
  isDownloading?: boolean;
}) {
  const navigate = useNavigate();
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const [alertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const setCommentStatus = () => {
    props.addComment();
  };
  const editFilingMaster = () => {
    props.editMasterFilling();
  };

  const deleteFilingMaster = () => {
    props.deleteMasterRecord();
  };
  const displayClients = () => {
    props.displayClients();
  };
  // const downloadData = () => {
  //   props.downloadData();
  // };
  const downloadData = () => {
    props.downloadData();
  };
  const downloadDataHistory = () => {
    props.downloadDataHistory();
  };
  const displayAttachments = () => {
    props.displayAttachments();
  };

  const displayHistory = () => {
    props.displayHistory();
  };

  const showFilingMasterForm = () => {
    navigate("/filing-master", {
      state: { from: "/filing-master-list", mode: "add" },
    });
  };
  const footerContent = (
    <div>
      <PrimeButton
        label="OK"
        icon="pi pi-check"
        onClick={() => closeAlert()}
        autoFocus
      />
    </div>
  );

  const closeAlert = () => {
    setShowAlert(false);
  };
  return (
    <React.Fragment>
      <Dialog
        header="Info"
        visible={showAlert}
        style={{ width: "30vw" }}
        onHide={() => closeAlert()}
        footer={footerContent}
      >
        <p className="m-0">{alertMessage}</p>
      </Dialog>

      <Box sx={{ 
        width: "100%", 
        bgcolor: "white",
        borderRadius: "50px !important",
        padding: "16px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px"
      }}>
        <nav aria-label="main mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="">
                <ListItemButton disabled={props.isLoading} sx={{ justifyContent: "center", padding: "8px" }}>
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.filter_list} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Add Filing Master">
                <ListItemButton
                  onClick={showFilingMasterForm}
                  disabled={
                    !usePermission(
                      "MasterFilingList",
                      "addFiling",
                      props.draft
                    ) ||
                    props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.post_add} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
          </List>
        </nav>
        <Divider sx={{ width: "80%", bgcolor: primaryColor }} />
        <nav aria-label="secondary mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Comments">
                <ListItemButton
                  onClick={setCommentStatus}
                  disabled={
                    !usePermission("MasterFilingList", "comments", props.draft) ||
                    props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.comment} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Edit Filing Master">
                <ListItemButton
                  onClick={editFilingMaster}
                  disabled={
                    !usePermission(
                      "MasterFilingList",
                      "editFiling",
                      props.draft
                    ) ||
                    props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.edit} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Delete Filing Record">
                <ListItemButton
                  onClick={deleteFilingMaster}
                  disabled={
                    !usePermission(
                      "MasterFilingList",
                      "deleteFiling",
                      props.draft
                    ) ||
                    props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.delete} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Reference Documents">
                <ListItemButton
                  onClick={displayAttachments}
                  disabled={
                    !usePermission(
                      "MasterFilingList",
                      "referenceDocument",
                      props.draft
                    ) ||
                    props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.snippet_folder} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Activity History">
                <ListItemButton
                  onClick={displayHistory}
                  disabled={
                    !usePermission(
                      "MasterFilingList",
                      "activityHistory",
                      props.draft
                    )
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.history} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            {/* <ListItem disablePadding>
              <ListItemButton
                onClick={downloadData}
                disabled={props.isLoading}
              >
                <ToolTip title="Download">
                  <DownloadIcon />
                </ToolTip>
              </ListItemButton>
            </ListItem> */}
            {props.isTabValue ? (
              <ListItem disablePadding sx={{ justifyContent: "center" }}>
                <InlineDownloadProgress
                  isDownloading={!!props.isDownloading}
                  progress={props.downloadProgress || 0}
                  statusMsg={props.downloadStatusMsg || ""}
                  onClick={downloadDataHistory}
                />
              </ListItem>
            ) : (
              <ListItem disablePadding sx={{ justifyContent: "center" }}>
                <InlineDownloadProgress
                  isDownloading={!!props.isDownloading}
                  progress={props.downloadProgress || 0}
                  statusMsg={props.downloadStatusMsg || ""}
                  onClick={downloadData}
                  disabled={props.isLoading}
                />
              </ListItem>
            )}
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Associated Clients">
                <ListItemButton
                  onClick={displayClients}
                  disabled={
                    !usePermission(
                      "MasterFilingList",
                      "associatedClient",
                      props.draft
                    ) ||
                    props.isLoading
                  }
                  sx={{ justifyContent: "center", padding: "8px" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.people} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
          </List>
        </nav>
      </Box>
    </React.Fragment>
  );
}
